
import {Component, Prop, Vue} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'catalog-product-list',
  components: ServiceContainer().getComponents(),
})

export default class extends Vue {
  @Prop({required: true}) readonly dataSource: string;
  @Prop({default: 6}) private chunkSize: number;

  private get isLoading(): boolean {
    return this.$store.getters[`${this.dataSource}/isLoading`];
  }

  private get products(): Array<object> {
    return this.$store.getters[`${this.dataSource}/productList`];
  }

  private get productChunks(): Array<object> {
    return Array.from({length: Math.ceil(this.products.length / this.chunkSize)}, (v, i) => this.products.slice(i * this.chunkSize, i * this.chunkSize + this.chunkSize));
  }
}
